import React, { useState, useEffect, useContext } from 'react'
import {
    Row,
    Col,
    Form,
    FormGroup,
    Input,
    Card,
    CardBody,
    CardTitle,
    CardSubtitle,
    Button,
    Label,
    Table
} from 'reactstrap'
import ApiService from '../../../data/services/ApiService'
import { GeneralContext } from '../../../context'
import TagsInput from 'react-tagsinput'
import { Editor } from 'react-draft-wysiwyg'
import { EditorState, convertToRaw } from 'draft-js'
import { draftToMarkdown } from 'markdown-draft-js'
import toastr from 'toastr'
import Dropzone from "react-dropzone"
import { Link, withRouter } from 'react-router-dom'
import Select from 'react-select'
import CSelect from 'react-select/creatable'
import { SIZE_VARIANT_OPTION, buildProductVariantsFromImageFile } from '../../../helpers/ProductVariantPresets'
import { getProductImageUrl } from '../../../helpers/ProductMedia'

import 'react-tagsinput/react-tagsinput.css'
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"
import 'toastr/build/toastr.min.css'

const CreateForm = (props) => {
    const generalContext = useContext(GeneralContext)
    const { setLoading } = generalContext

    const genders = [ {
        label: 'Femenino',
        value: 'Femenino'
    }, {
        label: 'Masculino',
        value: 'Masculino'
    }, {
        label: 'Neutro',
        value: 'Neutro'
    }]

    const units = [{
        value: 'g',
        label: 'g'
    }, {
        value: 'kg',
        label: 'kg'
    }, {
        value: 'l',
        label: 'l'
    }, {
        value: 'ml',
        label: 'ml'
    }, {
        value: 'oz',
        label: 'oz'
    }, {
        value: 'lb',
        label: 'lb'
    }]

    const sizeUnits = [{
        value: 'cm',
        label: `Centímetros`
    }, {
        value: 'm',
        label: `Metros`
    }, {
        value: 'in',
        label: `Pulgadas`
    }, {
        value: 'mm',
        label: `Milímetros`
    }]

    const variantTypes = [{
        value: 'Tamaño',
        label: `Tamaño`
    }]

    const [categoryId, setCategoryId] = useState()
    const [subcategoryId, setSubCategoryId] = useState()
    const [brandId, setBrandId] = useState()
    const [sku, setSKU] = useState('')
    const [upc, setUPC] = useState('')
    const [barcode, setBarcode] = useState('')
    const [description, setDescription] = useState('')
    const [tags, setTags] = useState([])
    const [name, setName] = useState('')    
    const [featured] = useState(false)
    const [weight, setWeight] = useState()
    const [unit, setUnit] = useState('')
    const [weightUnit, setWeightUnit] = useState({
        value: 'g',
        label: 'g'
    })
    const [sizeUnit, setSizeUnit] = useState({
        value: 'cm',
        label: `Centímetros`
    })
    const [gender, setGender] = useState({
        label: 'Neutro',
        value: 'Neutro'
    })
    const [model, setModel] = useState('')
    const [boxHeight, setBoxHeight] = useState()
    const [boxLength, setBoxLength] = useState()
    const [boxWidth, setBoxWidth] = useState()
    const [unitCost, setUnitCost] = useState()
    const [unitPrice, setUnitPrice] = useState()
    const [itHasVariants, setItHasVariants] = useState(true)
    const [variants, setVariants] = useState([])
    const [editorState, setEditorState] = useState(EditorState.createEmpty())
    const [variantOptions, setVariantOptions] = useState(variantTypes)
    const [images, setImages] = useState([])

    const [tempVariant, setTempVariant] = useState({
        name: false,
        barcode: false,
        sku: false,
        unitCost: 0,
        unitPrice: 0,
        weight: '',
        weightUnit: 'kg',
        boxLength: '',
        boxWidth: '',
        boxHeight: '',
        sizeUnit: 'cm',
        options: [],
        isStockManaged: false
    })

    // Relations
    const [categories, setCategories] = useState([])
    const [subcategories, setSubCategories] = useState([])
    const [brands, setBrands] = useState([])

    useEffect(() => {
        (async () => {
            await fetchCategories()
            await fetchBrands()
        })()

        setBarcode(`BC-${Math.floor(10000 + Math.random() * 90000)}`)
    }, []) // eslint-disable-line

    async function fetchBrands() {
        try {
            setLoading(true)
            const response = await ApiService.getBrands()
            let brands = []

            response.data.data.map((brand) => {
                const item = {
                    value: brand.id,
                    label: brand.name,
                }

                return brands.push(item)
            })

            setBrands(brands)
        } catch (error) {
            toastr.error(`No pude obtener marcas`)
        } finally {
            setLoading(false)
        }
    }

    async function fetchCategories() {
        try {
            setLoading(true)
            const response = await ApiService.getCategories()
            let data = []

            response.data.data.map((item) => {
                return data.push({
                    value: item.id,
                    label: item.name,
                    slug: item.slug
                })
            })

            setCategories(data)
            } catch (error) {
            toastr.error(`no pude obtener categorías`)
        } finally {
            setLoading(false)
        }
    }

    async function fetchSubcategories(id) {
        try {
            setLoading(true)
            const response = await ApiService.getSubcategoriesByCategoryId(id)
            let data = []

            response.data.subcategories.map((item) => {
                return data.push({
                    value: item.id,
                    label: item.name,
                    slug: item.slug
                })
            })

            setSubCategories(data)
        } catch (error) {
            toastr.error(`no pude obtener subcategorías`)
        } finally {
            setLoading(false)
        }
    }

    const onEditorStateChange = (editorState) => {
        const description = draftToMarkdown(convertToRaw(editorState.getCurrentContent()))

        setEditorState(editorState)
        setDescription(description)
    }

    const handleAcceptedFiles = async (files) => {
        if (!categoryId || !subcategoryId) {
            toastr.error(`Selecciona categoría y subcategoría antes de subir imágenes`, 'Error')

            return
        }

        try {
            const shouldGenerateVariants = images.length === 0 && files.length > 0
            let generatedVariants

            if (shouldGenerateVariants) {
                const result = await buildProductVariantsFromImageFile(files[0], name, sku)
                generatedVariants = result.variants
            }

            let data = [...images]
            for (let file of files) {
                setLoading(true)
                const formData = new FormData()
                formData.append('file', file)
                let response = await ApiService.uploadProductImage(formData)
    
                data.push({
                    imageUrl: response?.data?.imageUrl || response?.data?.imageURL,
                    fileName: response?.data?.fileName,
                    path: response?.data?.path,
                    url: response?.data?.url,
                    preview: URL.createObjectURL(file),
                    formattedSize: formatBytes(file.size)
                })
            }

            setImages(data)
            if (generatedVariants) {
                setItHasVariants(true)
                setVariantOptions([SIZE_VARIANT_OPTION])
                setVariants(generatedVariants)
            }
        } catch (error) {
            toastr.error(`No pude subir la imagen`)
        } finally {
            setLoading(false)
        }
    }

    const formatBytes = (bytes, decimals = 2) => {
        if (bytes === 0) return "0 Bytes"
        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
    
        const i = Math.floor(Math.log(bytes) / Math.log(k))
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
    }

    const handleSubmit = (async (e) => {
        e.preventDefault()
        
        if (!_validateForm()) {
            toastr.error(`No te olvides llenar los campos`, 'Warning')

            return
        }

        try {
            setLoading(true)

            const persistedImages = images.map(({ preview, url, formattedSize, ...image }) => image)
            const data = {
                name,
                description,
                tags,
                upc,
                sku,
                barcode,
                model,
                gender: gender.value,
                categoryId: categoryId.value,
                subcategoryId: subcategoryId.value,
                brandId: brandId.value,
                weight,
                weightUnit: weightUnit.value,
                sizeUnit: sizeUnit.value,
                boxHeight,
                boxLength,
                boxWidth,
                unitCost,
                unit,
                featured,
                isStockManaged: false,
                itHasVariants,
                variantOptions,
                variants: variants.map(({ unitPrice, wholeSalePrice, ...variant }) => ({ ...variant, isStockManaged: false })),
                images: persistedImages
            }
            const response = await ApiService.createProduct(data)

            if (!response.data.success) {
                toastr.error(`No pude agregar este producto`, 'Error')

                return
            }

            toastr.success(`Producto agregado correctamente`, '¡Éxito!')
            _clearForm()
        } catch (error) {
            toastr.error(`No pude agregar este producto`, 'Error')
        } finally {
            setLoading(false)
        }
    })

    const _handleCategoryChange = async (option) => {
        setCategoryId(option)
        setSubCategoryId()
        setImages([])
        await fetchSubcategories(option.value)
    }

    const getImageSrc = (image) => {
        if (image.preview) { return image.preview }
        return getProductImageUrl(image, {
            category: categoryId,
            subcategory: subcategoryId
        })
    }

    const _validateForm = () => {
        if (name === '') { return false }
        if (barcode === '') { return false }
        if (!categoryId) { return false }
        if (!subcategoryId) { return false }
        if (!brandId) { return false }
        if (itHasVariants && variants.length < 1) { return false }

        return true
    }

    const _clearForm = () => {
        document.getElementById('name').focus()

        setName('')
        setModel('')
        setBarcode('')
        setSKU('')
        setUPC('')
        setGender({
            label: 'Neutro',
            value: 'Neutro'
        })
        setTags([])
        setCategoryId('')
        setSubCategoryId('')
        setBrandId('')
        setWeight(0)
        setWeightUnit({
            value: 'g',
            label: 'g'
        })
        setSizeUnit({
            label: `Centímetros`,
            value: 'cm'
        })
        setVariants([])
        setItHasVariants(true)
        setVariantOptions(variantTypes)
        setEditorState(EditorState.createEmpty())
        setUnitCost('')
        setUnitPrice('')
        setImages([])
        setUnit('')

        setTempVariant({
            name: false,
            barcode: false,
            sku: false,
            unitCost: false,
            unitPrice: false,
            options:[],
            isStockManaged: false
        })
    }

    const _deleteVariant = async (i) => {
        const data = [...variants]
        data.splice(i, 1)

        setVariants(data)
    }

    const _updateVariantField = (index, field, value) => {
        const data = [...variants]
        data[index] = {
            ...data[index],
            [field]: value
        }

        if (field === 'unitPrice') {
            data[index].wholeSalePrice = value
        }

        setVariants(data)
    }

    const _updateVariantOption = (variantIndex, optionIndex, option, value) => {
        const data = [...variants]
        const options = [...(data[variantIndex].options || [])]
        options[optionIndex] = {
            label: option.label,
            value
        }

        data[variantIndex] = {
            ...data[variantIndex],
            options
        }

        setVariants(data)
    }

    const _addProductVariant = async (e) => {
        e.preventDefault()
        let variant = {...tempVariant}
        const sizeOption = variant.options.find(option => option && ['Tamaño', 'Medida'].includes(option.label))
        const size = sizeOption?.value

        if (
            variant.unitCost === false ||
            !size
        ) {
            toastr.error(`Por favor llena los datos de la variante`, 'Error')

            return
        }

        let data = [...variants]
        const variantName = variant.name || `${name} ${size}`
        const variantSku = variant.sku || [sku, size].filter(Boolean).join('-').replace(/\s+/g, '-').toUpperCase()

        data.push({
            ...variant,
            name: variantName,
            sku: variantSku,
            weight: variant.weight || weight,
            weightUnit: variant.weightUnit || weightUnit.value,
            boxLength: variant.boxLength || boxLength,
            boxWidth: variant.boxWidth || boxWidth,
            boxHeight: variant.boxHeight || boxHeight,
            sizeUnit: variant.sizeUnit || sizeUnit.value
        })
        setVariants(data)
        setTempVariant({
            name: false,
            barcode: false,
            sku: false,
            unitCost: 0,
            unitPrice: 0,
            weight: '',
            weightUnit: 'kg',
            boxLength: '',
            boxWidth: '',
            boxHeight: '',
            sizeUnit: 'cm',
            options: [],
            isStockManaged: false
        })

        toastr.success(`Variante agregada`, 'Éxito')
    }

    return(
        <React.Fragment>
            <Form id="product-create" method="POST" onSubmit={ handleSubmit }>
                <Row>
                    <Col sm={12} xs={12}>
                        <Card style={{textAlign: 'right'}}>
                            <CardBody>
                                <Link 
                                    className="btn btn-default waves-effect waves-light mb-2 mr-2"
                                    to="/products"
                                >
                                    Cancelar
                                </Link>

                                <Button
                                    type="submit"
                                    color="primary"
                                    className="btn btn-primary waves-effect waves-light mb-2 mr-2"
                                >
                                    <i className={`mdi mdi-check`}></i> Guardar Producto
                                </Button>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col sm={12} xs={12}>
                        <Card>
                            <CardBody>
                                <Row>
                                    <Col sm={4} xs={12}>
                                        <CardTitle>
                                            Clasificación del Producto
                                        </CardTitle>
                                        <CardSubtitle className="mb-3">
                                            Selecciona la categoría y subcategoría antes de subir imágenes.
                                        </CardSubtitle>
                                    </Col>

                                    <Col sm={8} xs={12}>
                                        <Row>
                                            <Col sm={6}>
                                                <FormGroup>
                                                    <Label className="control-label">
                                                        Categoría *
                                                    </Label>

                                                    <Select 
                                                        value={categoryId}
                                                        placeholder={`Seleccionar categoría`}
                                                        onChange={ _handleCategoryChange }
                                                        options={categories} 
                                                    />
                                                </FormGroup>
                                            </Col>

                                            <Col sm={6}>
                                                <FormGroup>
                                                    <Label className="control-label">
                                                        Subcategoría *
                                                    </Label>

                                                    <Select 
                                                        value={subcategoryId}
                                                        placeholder={`Selecciona una subcategoría`}
                                                        onChange={ value => setSubCategoryId(value) }
                                                        options={subcategories} 
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col sm={12} xs={12}>
                        <Card>
                            <CardBody>
                                <Row>
                                    <Col sm={4} xs={12}>
                                        <CardTitle>
                                            Información del Producto
                                        </CardTitle>
                                        <CardSubtitle className="mb-3">
                                            Ponle nombre y descripción a tu producto. 
                                            Considera que, si estos productos los vas 
                                            a vender en línea, entre más clara sea la
                                            información del producto, más fácil será 
                                            para tus clientes descubrir y comprar tus
                                            productos.
                                        </CardSubtitle>

                                        <CardBody>
                                            <Dropzone
                                                onDrop={acceptedFiles => {
                                                    handleAcceptedFiles(acceptedFiles)
                                                }}
                                                >
                                                {({ getRootProps, getInputProps }) => (
                                                    <div className="dropzone">
                                                        <div
                                                            className="dz-message needsclick"
                                                            {...getRootProps()}
                                                        >
                                                            <input {...getInputProps()} />
                                                            <div style={{ textAlign: 'center', paddingTop: '48px' }}
                                                                className="dz-message needsclick">
                                                                <div className="mb-3">
                                                                    <i className="display-4 text-muted bx bxs-cloud-upload" />
                                                                </div>

                                                                <h4>Arrastra y suelta la imagen del producto o da click para seleccionar una</h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </Dropzone>
                                            <div className="dropzone-previews mt-3" id="file-previews">
                                                <Row>
                                                    {images.map((f, i) => {
                                                        return (                                                            
                                                            <Col key={i} className="col-auto">
                                                                <img
                                                                    height={250}
                                                                    data-dz-thumbnail=""
                                                                    className="avatar-sm rounded bg-light"
                                                                    alt={f.name}
                                                                    src={getImageSrc(f)}
                                                                />
                                                            </Col>
                                                        )
                                                    })}
                                                </Row>
                                            </div>
                                        </CardBody>
                                    </Col>

                                    <Col sm={8} xs={12}>
                                        <Col sm={12}>
                                            <FormGroup>
                                                <Label htmlFor="name">
                                                    Nombre de Producto *
                                                </Label>
                                                <Input
                                                    id="name"
                                                    name="productName"
                                                    type="text"
                                                    placeholder={`Macbook Pro 16"`}
                                                    className="form-control"
                                                    value={name}
                                                    required
                                                    onChange={(event) => { setName(event?.target?.value) }}
                                                />
                                            </FormGroup>
                                        </Col>

                                        <FormGroup>
                                            <Label htmlFor="description">
                                                Descripción de Producto
                                            </Label>
                                            <Editor
                                                editorClassName="draftjs"
                                                editorState={editorState}
                                                onEditorStateChange={onEditorStateChange}
                                            />
                                        </FormGroup>

                                        <FormGroup>
                                            <Label className="control-label">
                                                Etiquetas
                                            </Label>
                                            <TagsInput
                                                onlyUnique={true}
                                                addKeys={[9, 13, 32, 186, 188]}
                                                value={tags}
                                                onChange={(value) => setTags(value)}
                                                pasteSplit={data => {
                                                    const separators = [',', ';', '\\(', '\\)', '\\*', '/', ':', '\\?', '\n', '\r']

                                                    return data.split(new RegExp(separators.join('|'))).map(d => d.trim())
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>

                        <Card>
                            <CardBody>
                                <Row>
                                    <Col sm={4} xs={12}>
                                        <CardTitle>
                                            Detalles generales del Producto
                                        </CardTitle>
                                        <CardSubtitle className="mb-3">
                                            No todos los campos son obligatorios
                                            para dar de alta un producto, pero, 
                                            en nuestra experiencia, entre más
                                            datos tengas de tus productos,
                                            más eficiente es tu organización de inventarios
                                            y categorización en tus canales de ventas.
                                        </CardSubtitle>
                                    </Col>

                                    <Col sm={8} xs={12}>
                                        <Row>
                                            <Col sm={4}>
                                                <FormGroup>
                                                    <Label htmlFor="barcode">
                                                        <i className='mdi mdi-barcode-scan'></i> Código de Barras
                                                    </Label>
                                                    <Input
                                                        id="barcode"
                                                        name="barcode"
                                                        type="text"
                                                        className="form-control"
                                                        value={barcode}
                                                        required
                                                        onChange={(event) => setBarcode(event.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col sm={4}>
                                                <FormGroup>
                                                    <Label htmlFor="sku">
                                                        SKU
                                                    </Label>
                                                    <Input
                                                        id="sku"
                                                        name="sku"
                                                        type="text"
                                                        className="form-control"
                                                        value={sku}
                                                        maxLength={15}
                                                        onChange={(event) => setSKU(event.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>

                                            <Col sm={4}>
                                                <FormGroup>
                                                    <Label htmlFor="upc">
                                                        UPC
                                                    </Label>
                                                    <Input
                                                        id="upc"
                                                        name="upc"
                                                        type="text"
                                                        maxLength={12}
                                                        className="form-control"
                                                        value={upc}
                                                        onChange={(event) => setUPC(event.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col sm={4}>
                                                <FormGroup>
                                                    <Label htmlFor="model">
                                                        Modelo
                                                    </Label>
                                                    <Input
                                                        id="model"
                                                        name="model"
                                                        type="text"
                                                        className="form-control"
                                                        value={model}
                                                        onChange={(event) => setModel(event.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>

                                            <Col sm={4}>
                                                <FormGroup>
                                                    <Label htmlFor="upc">
                                                        Género
                                                    </Label>

                                                    <Select 
                                                        id="gender"
                                                        defaultValue={gender}
                                                        onChange={value => setGender(value)}
                                                        options={genders} />
                                                </FormGroup>
                                            </Col>

                                            <Col sm={4}>
                                                <FormGroup>
                                                    <Label className="control-label">
                                                        Marca *
                                                    </Label>

                                                    <Select 
                                                        default={brandId}
                                                        placeholder={`Seleccionar marca`}
                                                        onChange={ value => setBrandId(value) }
                                                        options={brands} 
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>

                        <Card>
                            <CardBody>
                                <Row>
                                    <Col sm={4} xs={12}>
                                        <CardTitle>
                                            Variaciones de Producto <small> Se creará automáticamente una variación única, a menos que actives múltiples variaciones.</small>
                                        </CardTitle>

                                        <CardSubtitle>
                                            <p>
                                                Canvas Express usa variantes por tamaño. Cada tamaño tiene su propio precio base.
                                            </p>

                                            <div className="custom-control custom-checkbox mb-3">
                                                <input type="checkbox" className="custom-control-input" id="CustomCheck1" onChange={() => false} checked={itHasVariants} />
                                                <label className="custom-control-label" onClick={() => {
                                                    setItHasVariants(!itHasVariants)
                                                    }} >
                                                        Este producto tiene múltiples variaciones.
                                                </label>
                                            </div>
                                        </CardSubtitle>
                                    </Col>

                                    <Col sm={8} xs={12}>
                                    {itHasVariants && (
                                        <React.Fragment>
                                            <CSelect
                                                placeholder={`Selecciona Tamaño`}
                                                value={variantOptions}
                                                options={variantTypes}
                                                onChange={(value) => {
                                                    setVariantOptions(value || [])
                                                }}
                                                isClearable={false}
                                                isSearcheable
                                                isMulti={true}
                                            />
                                        </React.Fragment>
                                    )}
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>

                        {(itHasVariants && variantOptions?.length > 0) && (
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col sm={12}>
                                            <Table className={'table'}>
                                                <thead>
                                                    <tr>
                                                        <th>SKU</th>
                                                        <th>Barcode</th>
                                                        <th>Nombre de Variante</th>
                                                        {variantOptions?.map((o, i) => {
                                                            return (
                                                                <React.Fragment key={i}>
                                                                    <th>{o.label}</th>
                                                                </React.Fragment>
                                                            )
                                                        })}
                                                        <th>Costo Unitario</th>
                                                        <th>Precio Unitario</th>
                                                        <th>Peso</th>
                                                        <th>Largo</th>
                                                        <th>Ancho</th>
                                                        <th>Alto</th>
                                                        <th>...</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {variants[0] && (
                                                        <React.Fragment>
                                                            {variants.map((v, i) => {
                                                                return (
                                                                    <tr key={i}>
                                                                        <td>
                                                                            <Input
                                                                                type="text"
                                                                                value={v.sku || ''}
                                                                                onChange={(event) => _updateVariantField(i, 'sku', event.target.value)}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <Input
                                                                                type="text"
                                                                                value={v.barcode || ''}
                                                                                onChange={(event) => _updateVariantField(i, 'barcode', event.target.value)}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <Input
                                                                                type="text"
                                                                                value={v.name || ''}
                                                                                onChange={(event) => _updateVariantField(i, 'name', event.target.value)}
                                                                            />
                                                                        </td>
                                                                        {variantOptions.map((o, optionIndex) => {
                                                                            const optionValue = v.options?.[optionIndex]?.value || ''
                                                                            return (
                                                                                <td key={optionIndex}>
                                                                                    <Input
                                                                                        type="text"
                                                                                        value={optionValue}
                                                                                        onChange={(event) => _updateVariantOption(i, optionIndex, o, event.target.value)}
                                                                                    />
                                                                                </td>
                                                                            )
                                                                        })}
                                                                        <td>
                                                                            <Input
                                                                                type="number"
                                                                                value={v.unitCost || 0}
                                                                                onChange={(event) => _updateVariantField(i, 'unitCost', event.target.value)}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <span className="text-muted">Calculado por configuración</span>
                                                                        </td>
                                                                        <td>
                                                                            <Input
                                                                                type="number"
                                                                                value={v.weight || ''}
                                                                                placeholder={weight || 'kg'}
                                                                                onChange={(event) => _updateVariantField(i, 'weight', event.target.value)}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <Input
                                                                                type="number"
                                                                                value={v.boxLength || ''}
                                                                                placeholder={boxLength || 'cm'}
                                                                                onChange={(event) => _updateVariantField(i, 'boxLength', event.target.value)}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <Input
                                                                                type="number"
                                                                                value={v.boxWidth || ''}
                                                                                placeholder={boxWidth || 'cm'}
                                                                                onChange={(event) => _updateVariantField(i, 'boxWidth', event.target.value)}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <Input
                                                                                type="number"
                                                                                value={v.boxHeight || ''}
                                                                                placeholder={boxHeight || 'cm'}
                                                                                onChange={(event) => _updateVariantField(i, 'boxHeight', event.target.value)}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <button onClick={(e) => {
                                                                                    e.preventDefault()
                                                                                    _deleteVariant(i)
                                                                                }}
                                                                                className="btn btn-small btn-default">
                                                                                <i className="mdi mdi-delete"></i>
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })}
                                                        </React.Fragment>
                                                    )}
                                                    <tr>
                                                        <td>
                                                            <Input
                                                                type="text"
                                                                placeholder="SKU"
                                                                className="form-control"
                                                                onChange={(event) => {
                                                                    setTempVariant({
                                                                        ...tempVariant,
                                                                        sku: event.target.value
                                                                    })
                                                                }}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Input
                                                                type="text"
                                                                placeholder={`Código de barras`}
                                                                className="form-control"
                                                                onChange={(event) => {
                                                                    setTempVariant({
                                                                        ...tempVariant,
                                                                        barcode: event.target.value
                                                                    })
                                                                }}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Input
                                                                type="text"
                                                                placeholder="Nombre"
                                                                className="form-control"
                                                                onChange={(event) => {
                                                                    setTempVariant({
                                                                        ...tempVariant,
                                                                        name: event.target.value
                                                                    })
                                                                }}
                                                            />
                                                        </td>
                                                        {variantOptions.map((o, i) => {
                                                            return (
                                                                <td key={i}>
                                                                    <Input
                                                                        type="text"
                                                                        placeholder={o.label}
                                                                        className="form-control"
                                                                        onChange={(event) => {
                                                                            const { value } = event.target
                                                                            const options = [...tempVariant.options]
                                                                            options[i] = {
                                                                                label: o.label,
                                                                                value
                                                                            }

                                                                            setTempVariant({
                                                                                ...tempVariant,
                                                                                options
                                                                            })
                                                                        }}
                                                                    />
                                                                </td>
                                                            )
                                                        })}
                                                        <td>
                                                            <Input
                                                                type="number"
                                                                placeholder="Costo Unitario"
                                                                className="form-control"
                                                                onChange={(event) => {
                                                                    setTempVariant({
                                                                        ...tempVariant,
                                                                        unitCost: event.target.value
                                                                    })
                                                                }}
                                                            />
                                                        </td>

                                                        <td>
                                                            <span className="text-muted">Se calculará desde PrintPrices al guardar</span>
                                                        </td>

                                                        <td>
                                                            <Input
                                                                type="number"
                                                                placeholder="Peso"
                                                                className="form-control"
                                                                onChange={(event) => {
                                                                    setTempVariant({
                                                                        ...tempVariant,
                                                                        weight: event.target.value,
                                                                        weightUnit: weightUnit.value
                                                                    })
                                                                }}
                                                            />
                                                        </td>

                                                        <td>
                                                            <Input
                                                                type="number"
                                                                placeholder="Largo"
                                                                className="form-control"
                                                                onChange={(event) => {
                                                                    setTempVariant({
                                                                        ...tempVariant,
                                                                        boxLength: event.target.value,
                                                                        sizeUnit: sizeUnit.value
                                                                    })
                                                                }}
                                                            />
                                                        </td>

                                                        <td>
                                                            <Input
                                                                type="number"
                                                                placeholder="Ancho"
                                                                className="form-control"
                                                                onChange={(event) => {
                                                                    setTempVariant({
                                                                        ...tempVariant,
                                                                        boxWidth: event.target.value,
                                                                        sizeUnit: sizeUnit.value
                                                                    })
                                                                }}
                                                            />
                                                        </td>

                                                        <td>
                                                            <Input
                                                                type="number"
                                                                placeholder="Alto"
                                                                className="form-control"
                                                                onChange={(event) => {
                                                                    setTempVariant({
                                                                        ...tempVariant,
                                                                        boxHeight: event.target.value,
                                                                        sizeUnit: sizeUnit.value
                                                                    })
                                                                }}
                                                            />
                                                        </td>

                                                        <td>
                                                            <Button
                                                                style={{ padding: '4px 16px' }}
                                                                className="btn btn-success waves-effect waves-light mb-2 mr-2"
                                                                onClick={ _addProductVariant }>
                                                                <i className="mdi mdi-plus"></i>
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        )}
                    </Col>
                </Row>
            </Form>
        </React.Fragment>
    )
}

export default withRouter(CreateForm)
